<template>
    <div>
        <b-card no-body>
            <b-card-header>
                <span class="h5">
                    Pleito -<b-badge variant="warning" class="ml-2">{{ operacao }}</b-badge>
                </span>
            </b-card-header>
            <b-card-body>
                <app-erros-box
                    :erros="erros"
                    v-if="erros.length > 0"
                ></app-erros-box>
                <div>
                    <b-row>
                        <b-col md="6">
                            <b-form-group>
                                <label class="required">Nome do Projeto/Pleito</label>
                                <b-input-group>
                                    <b-form-textarea
                                        type="text"
                                        v-model="descritivo"
                                        placeholder="Nome do Projeto/Pleito"
                                        :rows="6"
                                    ></b-form-textarea>
                                    <b-form-invalid-feedback>O Nome do Projeto/Pleito é obrigatório</b-form-invalid-feedback>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col md="4" deck>
                            <b-card header="Prazo de Vigência"  header-bg-variant="transparent" class="text-center" border-variant="light" >
                                <b-row>
                                <b-col md="6">
                                    <b-form-group>
                                        <label class="required">Data Inicial</label>
                                        <b-input-group>
                                            <date-picker
                                                v-model="dataInicio"
                                                :config="$datePickerOptions"
                                            ></date-picker>
                                            <b-form-invalid-feedback>A data inicial é obrigatória</b-form-invalid-feedback>
                                        </b-input-group>
                                    </b-form-group>
                                </b-col> 
                                <b-col md="6">
                                    <b-form-group>
                                        <label class="required">Data Final</label>
                                        <b-input-group>
                                            <date-picker
                                                v-model="dataFim"
                                                :config="$datePickerOptions"
                                            ></date-picker>
                                            <b-form-invalid-feedback>A data final é obrigatória</b-form-invalid-feedback>
                                        </b-input-group>
                                    </b-form-group>
                                </b-col> 
                            </b-row>
                            </b-card>
                        </b-col>
                        
                        <b-col md="2">
                            <b-form-group>
                                <label class="required">Fonte de Recursos</label>
                                <b-input-group>
                                    <b-form-select
                                        v-model="fonteDeRecurso"
                                        type="text"
                                        :options="fontesDeRecursos"
                                        value-field="value"
                                        text-field="text">
                                    </b-form-select>
                                    <b-form-invalid-feedback>Gestor é obrigatório</b-form-invalid-feedback>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="12">
                            <b-form-group>
                                <label class="required">Público Alvo</label>
                                <b-input-group>
                                    <b-form-textarea
                                        type="text"
                                        v-model="publicoAlvo"
                                        placeholder="Público alvo"
                                        :rows="1"
                                    ></b-form-textarea>
                                    <b-form-invalid-feedback>O público alvo é obrigatório</b-form-invalid-feedback>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col md="6">
                            <b-form-group >
                                <label class="required">Objetivos</label>
                                <b-input-group>
                                    <b-form-textarea
                                        type="text"
                                        v-model="objetivos"
                                        placeholder="Objetivos"
                                        :rows="3"
                                    ></b-form-textarea>
                                    <b-form-invalid-feedback>Os objetivos do Pleito são obrigatórios</b-form-invalid-feedback>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col md="6">
                            <b-form-group>
                                <label class="required">Vinculo com a estratégia do sistema SEBRAE</label>
                                <b-input-group>
                                    <b-form-textarea
                                        type="text"
                                        v-model="vinculoEstrategiaSebrae"
                                        :rows="2"
                                    ></b-form-textarea>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col md="6">
                            <b-form-group>
                                <label class="required">Justificativa da proposição</label>
                                <b-input-group>
                                    <b-form-textarea
                                        type="text"
                                        v-model="justificativaProposicao"
                                        :rows="2"
                                    ></b-form-textarea>
                                    <b-form-invalid-feedback>A justificativa é obrigatória</b-form-invalid-feedback>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col md="6">
                            <b-form-group>
                                <label class="required">Foco estratégico para projetos de atendimento ou especificação de demanda</label>
                                <b-input-group>
                                    <b-form-textarea
                                        type="text"
                                        v-model="focoEstrategico"
                                        :rows="2"
                                    ></b-form-textarea>
                                    <b-form-invalid-feedback>O foco estratégico é obrigatório</b-form-invalid-feedback>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col md="12">
                            <b-form-group>
                                <label class="required">Resultados Esperados (indicadores, metas a serem alcançadas e prazo de realização)</label>
                                <b-input-group>
                                    <b-form-textarea
                                        type="text"
                                        v-model="resultadoEsperado"
                                        :rows="2"
                                    ></b-form-textarea>
                                    <b-form-invalid-feedback>Os resultados são obrigatórios.</b-form-invalid-feedback>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col md="12">
                            <b-form-group>
                                <label>Justificativa de utilização de conta corrente única Pre-existente para movimentação dos Recursos do Convênio. </label>
                                <b-input-group>
                                    <b-form-textarea
                                        type="text"
                                        v-model="justificativaUtilizacaoContaCorrente"
                                        :rows="2"
                                    ></b-form-textarea>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col md="4">
                            <b-form-group>
                                <label>Bens Produzidos</label>
                                <b-input-group>
                                    <b-form-textarea
                                        type="text"
                                        v-model="bensProduzidos"
                                        :rows="2"
                                    ></b-form-textarea>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col md="4">
                            <b-form-group>
                                <label>Produção destes bens</label>
                                <b-input-group>
                                    <b-form-textarea
                                        type="text"
                                        v-model="producaoDestesBens"
                                        :rows="2"
                                    ></b-form-textarea>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col md="4">
                            <b-form-group>
                                <label>Propriedade</label>
                                <b-input-group>
                                    <b-form-textarea
                                        type="text"
                                        v-model="propriedade"
                                        :rows="2"
                                    ></b-form-textarea>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col md="6">
                            <b-form-group>
                                <label class="required">CNPJ</label>
                                <b-input-group>
                                    <b-form-input
                                        type="text"
                                        v-model="cnpj"
                                        placeholder="CNPJ"
                                        v-mask="['##.###.###/####-##']"
                                    ></b-form-input>
                                    <b-input-group-append>
                                        <b-button
                                            variant="primary"
                                            @click="pesquisarConvenente()"
                                            title="Clique para pesquisar o Proponente">
                                        <i class="fa fa-search"></i>
                                        </b-button>
                                    </b-input-group-append>
                                    <b-form-invalid-feedback>O CNPJ do Proponente é obrigatório</b-form-invalid-feedback>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col md="6">
                            <b-form-group>
                                <label>Nome Proponente</label>
                                <b-input-group>
                                    <b-form-input
                                        type="text"
                                        placeholder="Nome do Proponente"
                                        v-model="nomeProponente"
                                        :disabled="true"
                                    ></b-form-input>
                                </b-input-group>
                            </b-form-group>
                            <p>
                                <small>
                                    <a :class="{'valor-verde': this.inadimplente == false, 'valor-vermelho': this.inadimplente == true}">
                                        Status Parceiro: {{ this.situacao }}
                                    </a>
                                </small>
                            </p>
                        </b-col>
                        <b-col md="6">
                            <b-form-group>
                                <label class="required">Gestor</label>
                                <b-input-group>
                                    <b-form-select
                                    v-model="codGestor"
                                    type="text"
                                    :options="gestores"
                                    value-field="codFuncionario"
                                    text-field="nome">
                                </b-form-select>
                                <b-form-invalid-feedback>Gestor é obrigatório</b-form-invalid-feedback>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="6">
                        <b-form-group>
                            <label>Telefone</label>
                            <b-form-input
                                type="text"
                                maxlength="14"
                                v-model="telefone"
                                v-mask="'(##)#####-####'">
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="3">
                            <b-form-group>
                                <label class="required">CEP</label>
                                <b-input-group>
                                    <b-form-input
                                        maxlength="9"
                                        type="text"
                                        v-model="cep"
                                        @keypress.native.enter="pesquisarCep()"
                                        @input="$v.cep.$touch()"
                                        v-mask="'#####-###'">
                                    </b-form-input>
                                    <b-input-group-append>
                                        <b-input-group-text v-if="processandoCep">
                                            <i class="fa fa-circle-o-notch fa-spin"></i>
                                        </b-input-group-text>
                                        <b-button
                                            v-if="!processandoCep"
                                            variant="primary"
                                            @click="pesquisarCep()"
                                            title="Clique para pesquisar o CEP">
                                            <i class="fa fa-search"></i>
                                        </b-button>
                                    </b-input-group-append>
                                    <b-form-invalid-feedback>O CEP é obrigatório</b-form-invalid-feedback>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="5">
                            <b-form-group>
                                <label>Logradouro</label>
                                <b-form-input
                                    type="text"
                                    v-model="logradouro"
                                    @input="$v.logradouro.$touch()"
                                    :disabled="true"
                                ></b-form-input>
                                <b-form-invalid-feedback>O logradouro é obrigatório</b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                        <b-col md="1">
                            <b-form-group>
                                <label>Número</label>
                                <b-form-input
                                    ref="numero"
                                    type="text"
                                    v-model="numero"
                                    @input="$v.numero.$touch()"
                                ></b-form-input>
                                <b-form-invalid-feedback>O número é obrigatório</b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="2" lg="3">
                            <b-form-group>
                                <label>Complemento</label>
                                <b-form-input
                                    type="text"
                                    id="complemento"
                                    v-model="complemento"
                                    :disabled="disabled"
                                ></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="12" md="5">
                            <b-form-group>
                                <label>Cidade</label>
                                <b-form-input
                                    type="text"
                                    v-model="cidade"
                                    @input="$v.cidade.$touch()"
                                    :disabled="disabled"
                                ></b-form-input>
                                <b-form-invalid-feedback>A cidade é obrigatória</b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="2">
                            <b-form-group>
                                <label>UF</label>
                                <b-form-select
                                    id="uf"
                                    :plain="true"
                                    :options="estados"
                                    v-model="uf"
                                    :disabled="disabled"
                                ></b-form-select>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        
                    </b-row>
                </div> 
            </b-card-body>
            <b-card-footer>
                <b-button
                    variant="primary"
                    class="mr-2"
                    :disabled="this.$v.$invalid"
                    @click.stop="salvar()">
                    <span>
                        <i class="fa fa-save mr-2"></i> Salvar
                    </span>
                </b-button>
                <b-button variant="danger" @click.stop="voltar()" class="mr-2">
                    <span>
                        <i class="fa fa-history mr-2"></i> Voltar
                    </span>
                </b-button>
            </b-card-footer>
        </b-card>
    </div>
</template>

<style>
.valor-verde {
    color: rgb(86, 194, 91);
}

.valor-vermelho {
    color: red;
}
</style>

<script>
import { required } from 'vuelidate/lib/validators'
import { estados2 } from '../../../shared/consts/estados'
import axios from 'axios'

export default {

    validations: {
        descritivo: {
            required
        },
        dataInicio: {
            required
        },
        dataFim: {
            required
        },
        publicoAlvo: {
            required
        },
        objetivos: {
            required
        },
        justificativaProposicao: {
            required
        },
        vinculoEstrategiaSebrae: {
            required
        },
        focoEstrategico: {
            required
        },
        resultadoEsperado: {
            required
        },
        nomeProponente: {
            required
        },
        codGestor: {
            required
        },
        cep: {
            required
        },
        fonteDeRecurso: {
            required
        },
    },

    data() {
        return {
            telefone: null,
            pleito: null,
            disabled: false,
            descritivo : null,
            rotaListagem: null,
            dataInicio : null,
            dataFim : null,
            publicoAlvo : null,
            objetivos : null,
            vinculoEstrategiaSebrae : null,
            justificativaProposicao : null,
            focoEstrategico : null,
            resultadoEsperado : null,
            cnpj : null,
            nomeProponente : null,
            justificativaUtilizacaoContaCorrente: null,
            bensProduzidos: null,
            producaoDestesBens: null, 
            fontesDeRecursos: 
                [
                    { value: 0, text: 'Sebrae' },
                    { value: 1, text: 'Parceiro' }
                ]
            ,
            fonteDeRecurso: null,
            propriedade: null,
            processandoCep: false,
			logradouro: '',
			numero: '',
			complemento: '',
			cidade: '',
			uf: 'PE',
			cep: '',
			estados: estados2,
            operacao: '',
            pleitosServicos: null,
            erros: [],
            gestores: [],
            itensPorPagina: 5,
            codGestor : null,
            inadimplente: null,
            situacao: "",
        }
    },

    methods: {
        async importarServicos() {
            try {
                const roteName = this.$route.name
                if (roteName.includes('Fornecedor')) {
                    const FornecedorServicos = await import('../fornecedor/PleitosServicos')
                    this.pleitosServicos = FornecedorServicos.default
                    this.rotaListagem = 'Pleitos_Fornecedor'
                } else if (roteName.includes('Financeiro')) {
                    const FinanceiroServicos = await import('../financeiro/PleitosServicos')
                    this.pleitosServicos = FinanceiroServicos.default
                    this.rotaListagem = 'Pleitos_Financeiro'
                } else if (roteName.includes('Uai')) {
                    const UaiServicos = await import('../uai/PleitosServicos')
                    this.pleitosServicos = UaiServicos.default
                    this.rotaListagem = 'Pleitos_Uai'
                } else if (roteName.includes('Ucic')) {
                    const UcicServicos = await import('../ucic/PleitosServicos')
                    this.pleitosServicos = UcicServicos.default
                    this.rotaListagem = 'Pleitos_Ucic'
                }
            } catch (error) {
                console.error('Erro ao importar serviços:', error)
                this.$toast.error('Erro ao carregar serviços necessários')
            }
        },

        atualizarEndereco() {
			let endereco = {
				logradouro: this.logradouro,
				complemento: this.complemento,
				cidade: this.cidade,
				uf: this.uf,
				cep: this.cep.apenasNumeros(),
				valido: !this.$v.$invalid
			}
			this.$emit('input', endereco)
		},

		pesquisarCep() {
			if (this.cep.apenasNumeros().length === 8) {
				this.processandoCep = true
				let promisse = axios.get(
					`https://viacep.com.br/ws/${this.cep.apenasNumeros()}/json/`
				)
				promisse
					.then(response => {
						if (response.data.erro) {
							this.processandoCep = false
						} else {
							this.logradouro = response.data.logradouro.toUpperCase()
							this.bairro = response.data.bairro.toUpperCase()
							this.cidade = response.data.localidade.toUpperCase()
							this.uf = response.data.uf
							this.processandoCep = false
							this.$refs.numero.focus()
						}
					})
					.catch(response => {
						this.processandoCep = false
					})
			}
		},

		carregaEndereco() {
			if (this.value) {
				this.logradouro = this.value.logradouro
				this.numero = this.value.numero
				this.complemento = this.value.complemento
				this.bairro = this.value.bairro
				this.cidade = this.value.cidade
				if (this.value.uf) {
					this.uf = this.value.uf
				} else {
					this.uf = 'PE'
				}
				this.cep = this.$mask(this.value.cep, '#####-###')
			} else {
				this.uf = 'PE'
			}
		},

        voltar() {
            this.$router.push({ name: this.rotaListagem })
        },

        obterPleito() {
            this.$store.dispatch('addRequest')
            this.pleitosServicos.obterPleitoPorId(this.$route.params.pleitoId).then(
                response => {
                    if (response) {
                        if (response.success) {
                            this.pleito = response.data
                            this.preencher()
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        salvar(){
            let pleitoDto = {
                descritivo : this.descritivo,
                dataInicio : this.$moment(this.dataInicio, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                dataFim : this.$moment(this.dataFim, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                publicoAlvo : this.publicoAlvo,
                objetivos : this.objetivos,
                vinculoEstrategiaSebrae : this.vinculoEstrategiaSebrae,
                justificativaProposicao : this.justificativaProposicao,
                focoEstrategico : this.focoEstrategico,
                resultadoEsperado : this.resultadoEsperado,
                cnpj : this.cnpj.apenasNumeros(),
                nomeProponente : this.nomeProponente,
                justificativaUtilizacaoContaCorrente: this.justificativaUtilizacaoContaCorrente,
                bensProduzidos: this.bensProduzidos,
                producaoDestesBens: this.producaoDestesBens, 
                fonteDeRecurso: this.fonteDeRecurso,
                propriedade: this.propriedade,
                codGestor : this.codGestor,
                endereco: this.logradouro,
                numero: this.numero,
                complemento: this.complemento,
                cidade: this.cidade,
                uf: this.uf,
                cep: this.cep.apenasNumeros(),
                telefone: this.telefone
            }
            if (this.operacao == "INSERÇÃO"){
                this.$store.dispatch('addRequest')
                this.pleitosServicos.inserir(pleitoDto)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.pleito = response.data
                            this.voltar()
                        }
                        else{
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
            }else{
                this.$store.dispatch('addRequest')
                pleitoDto.pleitoId = this.pleito.pleitoId
                this.pleitosServicos.alterar(pleitoDto)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.pleito = response.data
                            this.voltar()
                        }
                        else{
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
            }
        },

        preencher(){
            this.descritivo = this.pleito.descritivo
            this.dataInicio = this.$moment(this.pleito.dataInicio, 'YYYY-MM-DD').format('DD/MM/YYYY')
            this.dataFim = this.$moment(this.pleito.dataFim, 'YYYY-MM-DD').format('DD/MM/YYYY')
            this.publicoAlvo = this.pleito.publicoAlvo
            this.objetivos = this.pleito.objetivos
            this.vinculoEstrategiaSebrae = this.pleito.vinculoEstrategiaSebrae
            this.justificativaProposicao = this.pleito.justificativaProposicao
            this.focoEstrategico = this.pleito.focoEstrategico
            this.resultadoEsperado = this.pleito.resultadoEsperado
            this.cnpj = this.pleito.cnpj
            this.nomeProponente = this.pleito.nomeProponente
            this.justificativaUtilizacaoContaCorrente = this.pleito.justificativaUtilizacaoContaCorrente
            this.bensProduzidos = this.pleito.bensProduzidos
            this.producaoDestesBens = this.pleito.producaoDestesBens
            this.fonteDeRecurso = this.pleito.fontesDeRecursos
            this.propriedade = this.pleito.propriedade
            this.codGestor = this.pleito.codGestor
            this.logradouro = this.pleito.endereco
            this.numero = this.pleito.numero
            this.complemento = this.pleito.complemento
            this.cidade = this.pleito.cidade
            this.uf = this.pleito.uf
            this.cep = this.$mask(this.pleito.cep, '#####-###')
            this.telefone = this.$mask(this.pleito.telefone, '(##)#####-####')
        },

        obterGestores(){
            this.$store.dispatch('addRequest')
            this.pleitosServicos.obterGestores().then(
                response => {
                    if (response) {
                        if (response.success) {
                            this.gestores = response.data
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                    })
        },

        pesquisarConvenente() {
            let cpfcnpjSemCaracteresEspeciais = this.cnpj.replace(/\D+/g, '')
            this.$store.dispatch('addRequest')
            this.pleitosServicos.obterFornecedor(cpfcnpjSemCaracteresEspeciais)
            .then(response => {
                if (response) {
                    if (response.success && response.data != null) {
                        this.erros = []
                        this.nomeProponente = response.data.nome
                        if(response.data.inadimplente == true){
                            this.situacao = "INADIMPLENTE"
                        } else {
                            this.situacao = "ADIMPLENTE"
                        }
                        this.inadimplente = response.data.inadimplente
                    } else {
                        this.erros.push('Convenente não encontrado')
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },
    },


    watch: {
		logradouro() {
			this.atualizarEndereco()
		},
		numero() {
			this.atualizarEndereco()
		},
		complemento() {
			this.atualizarEndereco()
		},
		bairro() {
			this.atualizarEndereco()
		},
		cidade() {
			this.atualizarEndereco()
		},
		uf() {
			this.atualizarEndereco()
		},
		cep() {
			this.atualizarEndereco()
		},
		value() {
			this.carregaEndereco()
		}
	},

    async created() {
        // Se os serviços vieram via parâmetros da rota (navegação via botão)
        if (this.$route.params.pleitosServicos) {
            this.pleitosServicos = this.$route.params.pleitosServicos
            this.rotaListagem = this.$route.params.rotaListagem
        } else {
            // Se acessou a rota diretamente, importa os serviços baseado na rota atual
            await this.importarServicos()
        }
        
        this.obterGestores()
        if(this.$route.name == 'Pleitos_Fornecedor_Inserir' 
            || this.$route.name == 'Pleitos_Financeiro_Inserir'
            || this.$route.name == 'Pleitos_Uai_Inserir'
            || this.$route.name == 'Pleitos_Ucic_Inserir'){
            this.operacao = "INSERÇÃO"
        } else {
            this.operacao = "ATUALIZAÇÃO"
            this.obterPleito()
        }
    }
}
</script>
